var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttitude(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 6802,
    transform: "translate(-776 -5243)",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -31.5,
    y: -31.5,
    width: 399,
    height: 311,
    rx: 15.5,
    stroke: "#202233",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    fill: "#FFEDD8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0166 55.522C31.4436 55.522 24.478 48.5564 24.478 39.9834C24.478 31.4104 31.4436 24.4448 40.0166 24.4448C48.5897 24.4448 55.5552 31.4104 55.5552 39.9834C55.5217 48.5564 48.5562 55.522 40.0166 55.522ZM40.0166 25.7844C32.1804 25.7844 25.7841 32.1806 25.7841 40.0169C25.7841 47.8532 32.1804 54.2495 40.0166 54.2495C47.8529 54.2495 54.2492 47.8532 54.2492 40.0169C54.2157 32.1471 47.8529 25.7844 40.0166 25.7844Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0167 58C30.0707 58 22 49.9293 22 40.0167C22 30.0707 30.0707 22 40.0167 22C49.9293 22 58.0335 30.0707 58.0335 40.0167C58 49.9293 49.9293 58 40.0167 58ZM40.0167 23.306C30.8074 23.306 23.306 30.8074 23.306 40.0167C23.306 49.226 30.8074 56.7274 40.0167 56.7274C49.226 56.7274 56.7274 49.226 56.7274 40.0167C56.694 30.8074 49.226 23.306 40.0167 23.306Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2586 28.7172L33.1274 29.3701L34.0147 30.9073L35.1459 30.2545L34.2586 28.7172Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3902 33.1236L28.7368 34.2544L30.2735 35.1424L30.9269 34.0116L29.3902 33.1236Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1328 39.3467H27.3579V40.6527H29.1328V39.3467Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2675 44.8844L28.7305 45.772L29.3836 46.903L30.9207 46.0154L30.2675 44.8844Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0058 49.0753L33.1182 50.6123L34.2492 51.2655L35.1368 49.7284L34.0058 49.0753Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6527 50.8667H39.3467V52.6416H40.6527V50.8667Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0111 49.0825L44.8799 49.7354L45.7671 51.2726L46.8983 50.6197L46.0111 49.0825Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7527 44.8858L49.0991 46.0166L50.6358 46.9048L51.2894 45.774L49.7527 44.8858Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7425 40.6527H41.8922V39.3466H51.4029C51.0681 33.3522 46.0783 28.5634 39.9834 28.5634V27.2573C47.016 27.2573 52.709 32.9503 52.709 39.9829V40.6527H52.7425Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0168 42.5624C38.6103 42.5624 37.4717 41.4238 37.4717 40.0173C37.4717 38.6108 38.6103 37.4722 40.0168 37.4722C41.4233 37.4722 42.5619 38.6108 42.5619 40.0173C42.5619 41.4238 41.4233 42.5624 40.0168 42.5624ZM40.0168 38.7447C39.3135 38.7447 38.7777 39.314 38.7777 39.9838C38.7777 40.6871 39.347 41.2229 40.0168 41.2229C40.7201 41.2229 41.2559 40.6536 41.2559 39.9838C41.2559 39.314 40.6866 38.7447 40.0168 38.7447Z",
    fill: "#FD7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6532 33.3193H39.3472V38.1082H40.6532V33.3193Z",
    fill: "#FD7E3B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 6802,
    fill: "white",
    transform: "translate(-776 -5243)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(22 22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttitude);
export default __webpack_public_path__ + "static/media/attitude.dd8caf625af8d68cb38fd761b68e21c6.svg";
export { ForwardRef as ReactComponent };